export default {
	title: "Centre d'échange de cadeaux",
	myPoints: "Mes points",
	SelectedGifts: "Cadeaux sélectionnés",
	form: {
		label: {
			title: "Recherche",
			points: "Points"
		}
	},
	redemption: "Racheté",
	stock: "Action",
	id: {
		redeemPoints: "Échangez les points requis: ",
		btn: "Échangez maintenant",
		title: "Avis de cadeau d’échange de points",
		content: `Cher travailleur, merci pour votre participation au travail.\n\nVeuillez lire les conditions suivantes avant d'échanger des points :\n\n[Points de travail] Après avoir terminé quotidiennement l'optimisation des données de l'ensemble de commandes, les travailleurs peuvent gagner 1 point cadeau, ce qui peut être utilisé pour un échange partiel de parrainage de cadeaux.\n[Échange de cadeaux] Les travailleurs doivent fournir des informations d'adresse de livraison pertinentes, et le cadeau sera expédié gratuitement dans le monde entier dans un délai de 14 jours. Une fois l'échange terminé, vous pouvez contacter le service client pour obtenir le numéro de suivi afin de suivre la progression du cadeau. La plateforme ne divulguera aucune information à des tiers.\nRemarque : Une fois les points échangés contre des cadeaux, ils ne peuvent pas être remboursés`
	},
	applyDialog: {
		title: "Recevoir des informations",
		form: {
			consignee: "Destinataire",
			area: "Zone",
			telephone: "Téléphone",
			deliveryAddress: "Adresse de livraison"
		},
		btn: "Soumettre à"
	},
	records: {
		title: "Enregistrements",
		status: ["Envoi en attente", "Expédié", "Livré", "Annulé"]
	}
};
